import { configureStore } from "@reduxjs/toolkit";
import agentSliceReducer from "./agentSlice";
import contactSliceReducer from './contactSlice';
import contactAttributeReducer from "./contactAttributeSlice";
import wisdomSliceReducer from './wisdom';
import callbackSliceReducer from './callbackSlice';
import voicemailSilceReducer from "./voicemailSilce";
import settingSliceReducer from "./settingSlice";
import emailSliceReducer from "./emailSlice";
import chatSliceReducer from "./chatSlice";

const store = configureStore({
    reducer: { 
        agentSlice: agentSliceReducer, 
        contactSlice:contactSliceReducer,
        contactAttributeSlice:contactAttributeReducer,
        wisdomSlice:wisdomSliceReducer,
        callbackSlice:callbackSliceReducer,
        voicemailSilce:voicemailSilceReducer,
        settingSlice:settingSliceReducer,
        emailSlice:emailSliceReducer,
        chatSlice: chatSliceReducer
    },
    middleware:(getDefaultMiddleware)=>getDefaultMiddleware({serializableCheck: false}),
});

export default store;